import { useEffect, useState } from "react"
import { collection, doc, getDoc, getDocs, getFirestore, limit, onSnapshot, orderBy, query, Timestamp, where } from "firebase/firestore";



export default function User(props) {

    const db = getFirestore();
    const [details, setDetails] = useState([{ "fullName": "loading" }]);

    useEffect(() => {
        getDoc(doc(db, "users", props.id)).then((doc) => {
            setDetails(doc.data());
        });

    }, []);


    return (
        <div className="flex flex-row justify-start items-center">

            <div className="text-xl text-black flex flex-row justify-between items-center p-2 bg-white rounded-md">

                <div className="flex justify-center font-normal items-center mr-5">{details["fullName"]}</div>

                <div style={{ backgroundImage: `url('${details["imgSrc"]}')` }} className="bg-cover bg-center h-16 w-16  rounded-md bg-white/10 flex justify-center items-center "></div>

            </div>

            <div className="h-10 p-3 ml-10 text-sm text-black font-normal flex justify-center items-center rounded-3xl bg-yellow-300">
                {props.val} Requests
            </div>

        </div>



    )

}